module.exports = __webpack_public_path__ + "static/media/essent-bw.69e6d627.jpg";